module.exports = __webpack_public_path__ + "img/TresLechesToken.15fe0190.gif";